import { SetStateAction } from "react";
import { EventParticipationAttendanceHistorySortParam } from "../../../model/EventParticipationHistory";

type Props = {
  stateHistorySortParam: EventParticipationAttendanceHistorySortParam;
  stateSetHistorySortParam: (value: SetStateAction<EventParticipationAttendanceHistorySortParam>) => void;
};

export const EventParticipationWebSearch = ({
  stateHistorySortParam,
  stateSetHistorySortParam
}: Props) => {
  const sortButtonDefaultStyle = "flex justify-center rounded-md shadow transition ease-in duration-200 h-10 w-[72px] md:w-24 px-1 md:px-3 text-sm font-medium items-center hover:bg-orange-500 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 focus:ring-offset-orange-100";
  const sortButtonStyle = "text-orange-500 bg-white border-2 border-orange-500";
  const sortSelectButtonStyle = "text-white bg-orange-500";

  return (
    <div className="flex flex-col">
      <div className="inline-block min-w-full align-middle">
        <div className="flex gap-2 md:gap-5 font-bold flex-wrap md:flex-nowrap justify-end md:justify-start">
          <div className="flex flex-row gap-1 flex-wrap md:gap-5">
            <div className="flex gap-1 items-center">
              <h3 className="text-sm text-gray-900 whitespace-pre">並び順：</h3>
            </div>
            <div className="flex gap-1 items-center self-end ml-auto">
              <div className="">
                <h3 className="text-sm text-gray-900 whitespace-pre">イベント開催日</h3>
              </div>
              <div className="ml-1 flex gap-2">
                <button
                  onClick={() =>
                    stateSetHistorySortParam({ title: null, eventAt: 'desc' })
                  }
                  className={`${sortButtonDefaultStyle} ${stateHistorySortParam.eventAt === 'desc' ? sortSelectButtonStyle : sortButtonStyle}`}
                >
                  新しい順
                </button>
                <button
                  onClick={() =>
                    stateSetHistorySortParam({ title: null, eventAt: 'asc' })
                  }
                  className={`${sortButtonDefaultStyle} ${stateHistorySortParam.eventAt === 'asc' ? sortSelectButtonStyle : sortButtonStyle}`}
                >
                  古い順
                </button>
              </div>
            </div>
          </div>
          <div className="flex gap-1 items-center">
            <div className="">
              <h3 className="text-sm text-gray-900">タイトル</h3>
            </div>
            <div className="ml-1 flex gap-2">
              <button
                onClick={() =>
                  stateSetHistorySortParam({ title: 'desc', eventAt: null })
                }
                className={`${sortButtonDefaultStyle} ${stateHistorySortParam.title === 'desc' ? sortSelectButtonStyle : sortButtonStyle}`}
              >
                降順
              </button>
              <button
                onClick={() =>
                  stateSetHistorySortParam({ title: 'asc', eventAt: null })
                }
                className={`${sortButtonDefaultStyle} ${stateHistorySortParam.title === 'asc' ? sortSelectButtonStyle : sortButtonStyle}`}
              >
                昇順
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};